
<div class="content-wrapper">
	<div class="content">
		<slot />
	</div>
	<div v-if="$slots['footer']" class="content-footer">
		<slot name="footer" />
	</div>
</div>
